import { render, staticRenderFns } from "./usefulLinks.vue?vue&type=template&id=489cb94f&scoped=true"
var script = {}
import style0 from "./usefulLinks.vue?vue&type=style&index=0&id=489cb94f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489cb94f",
  null
  
)

export default component.exports